var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-sans overflow-x-hidden",attrs:{"id":"app"}},[_c('About'),_c('Game'),_c('News'),_c('Job')],1)}
var staticRenderFns = []

export { render, staticRenderFns }